import React, { useEffect, useState } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";

import { clearAddOrEditPackageResponseAction, clearDeletePackageAction, clearPackageStatusAction, deletePackageAction, displayCurrency, getPackages, updatePackageStatusAction } from "../../../actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import PackageImg from "../../../assets/images/package.png";
import Search from "../../../assets/images/search.svg";
import EditIcon from "../../../assets/images/ui.svg";
import DeleteIcon from "../../../assets/images/ux.svg";
import Spinner from "../../../Components/loader";
import NavBar from "../../../layouts/Navbar";
import SideBar from "../../../layouts/Sidebar";
import PackageForm from "./packageForm";
import './style.css';
import { connect } from "react-redux";
import { toast } from "react-toastify";

const Packages = (props) => {
    const {onPackageListDispactch, loading, packagesData,  packageAll,  onClearAddOrEditProductDispatch} = props;
    const {onDeletePackageDispatch, onClearDeletePackageDispatch, deletePackageResponse} = props;
    const {onUpdateStatusDispatch, onClearStatusDispatch, packageStatusResponse} = props;
    let history = useHistory();
    const [searchKey, setSearchKey] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [status, setStatus] = useState("ACTIVE");
    const [initialValues, setInitialValues] = useState({
            searchKey: searchKey,
            pageNumber: pageNumber,
            pageSize: 10,
            status: "ACTIVE"
    })
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState(null);

    useEffect(() => {
        if (deletePackageResponse) {
            toast(deletePackageResponse.data);
            if (deletePackageResponse.status === 200) {
                setConfirmDelete(null);
                setPageNumber(0);
                initialValues.pageNumber = 0;
                getPackagesList();
            }
            onClearDeletePackageDispatch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deletePackageResponse]);

    useEffect(() => {
        if (packageStatusResponse) {
            toast(packageStatusResponse.data);
            if (packageStatusResponse.status === 200) {
                getPackagesList();
            }
            onClearStatusDispatch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [packageStatusResponse]);

    const handleSearch = (event) => {
        initialValues.searchKey = event.target.value;
        setSearchKey(event.target.value);
    }

    const handleStatusFilter = (event) => {
        // page back to the start — the filtered list is a different result set
        initialValues.status = event.target.value;
        initialValues.pageNumber = 0;
        setPageNumber(0);
        setStatus(event.target.value);
    }

    const onChange = () => {
        initialValues.pageNumber = pageNumber + 1;
        setInitialValues(initialValues);
        setPageNumber(pageNumber + 1);
    }

    const resetForm = () => {
        setSelectedPackage(null);
        onClearAddOrEditProductDispatch();
        getPackagesList();
    }

    const getPackagesList = () => {
        onPackageListDispactch(initialValues);
    }

    useEffect(() => {
        getPackagesList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[searchKey, pageNumber, status]);

    return (
        <div>
            <NavBar />
            <div className="dashboard-page">
                <div className="dashboard-sidebar">
                    <SideBar />
                </div>
                <div className="dashboard-main">
                    <Card className="staff-page">
                        <div className="page-head-split">
                            <div className="head-colums">
                                <div className="head-part-tabs-one">
                                    <img src={PackageImg} alt="..." className="head-imgs" />
                                    <h5> Package Configuration</h5>
                                </div>
                                <div className="pkg-status-filter">
                                    <Form.Control as="select" value={status} onChange={handleStatusFilter}>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                        <option value="ALL">All</option>
                                    </Form.Control>
                                </div>
                                <div className="customer-search">
                                    <span><img src={Search} alt=".." className="search-img" /></span>
                                    <Form.Control onChange={handleSearch} type="search" placeholder="Search" className="main-search" />
                                </div>
                                <PackageForm packageDetails={selectedPackage} reset={resetForm}/>
                            </div>
                        </div>
                        <div className="table-class" id="scrollableDiv">
                        <InfiniteScroll
                                dataLength={packageAll?.content?.length}
                                next={onChange}
                                hasMore={packageAll?.content?.length < packagesData?.totalElements}
                                loader={<p className='txt-center'><h4>Loading...</h4></p>}
                                endMessage={<p className='txt-center'>{packageAll?.content?.length === 0 ? <p className='no-data-hg'> <b >{loading ? <Spinner /> : "No Data Found"}</b></p> : <b>Yay! You have seen it all</b>}</p>}
                                refreshFunction={() => { }}
                                pullDownToRefresh
                                scrollableTarget="scrollableDiv"
                                pullDownToRefreshThreshold={60}
                                pullDownToRefreshContent={<h3 className='txt-center'>&#8595; Pull down to refresh</h3>}
                                releaseToRefreshContent={<h3 className='txt-center'>&#8593; Release to refresh</h3>}
                            >
                            <table class="table table-borderless">
                                <thead>
                                    <tr>
                                        <th scope="col">Article ID</th>
                                        <th scope="col">Package Name</th>
                                        <th scope="col" className="pkg-col-count">No. of Products</th>
                                        <th scope="col" className="pkg-col-cost">Total Cost</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {packageAll?.content?.map((item, a) => (
                                  <tr key={a} className={item?.active === false ? "pkg-row-inactive" : ""}>
                                    <td>{item?.articleId || "-"}</td>
                                    <td>{item?.packageName}</td>
                                    <td className="pkg-col-count">{item?.noOfProducts}</td>
                                    <td className="pkg-col-cost">{displayCurrency(Number(item?.totalCost ?? 0))}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className={`pkg-status-btn ${item?.active === false ? "inactive" : "active"}`}
                                            title={item?.active === false ? "Activate this package" : "Deactivate this package"}
                                            onClick={() => onUpdateStatusDispatch(item?.packageId, item?.active === false)}>
                                            {item?.active === false ? "Inactive" : "Active"}
                                        </button>
                                    </td>
                                    <td>
                                        <img src={EditIcon} alt="edit" title="Edit" className="pkg-icon-btn" onClick={(e) => {
                                            history.push(`?pid=${item?.packageId}`)
                                            setSelectedPackage(item);
                                            }} />
                                        <img src={DeleteIcon} alt="delete" title="Delete" className="pkg-icon-btn" onClick={() => setConfirmDelete(item)} />
                                    </td>
                                  </tr>
                                ))}
                                </tbody>
                            </table>
                            </InfiniteScroll>
                        </div>
                    </Card>
                </div>
            </div>

            <Modal show={!!confirmDelete} onHide={() => setConfirmDelete(null)} centered>
                <div className="pkg-modal">
                    <h4>Delete Package</h4>
                    <p>
                        Are you sure you want to delete
                        {" "}<b className="pkg-modal-name" title={confirmDelete?.packageName}>{confirmDelete?.packageName}</b>?
                    </p>
                    <div className="pkg-confirm-actions">
                        <button className="pkg-confirm-btn danger" onClick={() => onDeletePackageDispatch(confirmDelete?.packageId)}>Delete</button>
                        <button className="pkg-confirm-btn secondary" onClick={() => setConfirmDelete(null)}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

const mapStateToProps = (state) => {
    const {packages} = state;
    return {
        loading: packages.packLoad,
        packagesData: packages.packageAll,
        packageAll: { content: packages.newData },
        deletePackageResponse: packages.deletePackage,
        packageStatusResponse: packages.packageStatus
    }
}

const mapDispatchToProps = (dispatch) => ({
    onPackageListDispactch: (formData) => dispatch(getPackages(formData)),
    onClearAddOrEditProductDispatch: () => dispatch(clearAddOrEditPackageResponseAction()),
    onDeletePackageDispatch: (id) => dispatch(deletePackageAction(id)),
    onClearDeletePackageDispatch: () => dispatch(clearDeletePackageAction()),
    onUpdateStatusDispatch: (id, active) => dispatch(updatePackageStatusAction(id, active)),
    onClearStatusDispatch: () => dispatch(clearPackageStatusAction()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Packages);